import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    // Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";
import { TurnOverReports } from "../../../components/PDF/TurnOverReportPdf";
import { PDFDownloadLink } from "@react-pdf/renderer";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const TurnOverSummary = () => {
    const [pkgSalesItem, setPkgSalesItem] = useState([]);
    const [pkgTurnOverDate, setPkgTurnOverDate] = useState([]);
    const [pkgTotal, setPkgTotal] = useState([]);

    const [drSalesItem, setDrSalesItem] = useState([]);
    const [drTurnOverDate, setDrTurnOverDate] = useState([]);
    const [drTotal, setDrTotal] = useState([]);
    const [drPaymentTotal, setDrPaymentTotal] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
    const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
    const [mergedItems, setMergedItems] = useState([]);
    const classes = useStyles();
    // console.log(format(dateRange.startDate, "yyyy/MM/dd/"));
    // console.log(format(dateRange.endDate, "yyyy/MM/dd/"));
    const [branchidNo, setbranchidNo] = useState(get_cookies('branchidno'));

    const handleDataMerge = (packageItems, directItems) => {
        // Create a map to track types and their summed amounts
        const itemMap = new Map();

        // Function to add or sum items in the map
        const addItemToMap = (items) => {
          items.forEach((item) => {
            const amount = parseFloat(item.amount.replace(/,/g, '')); 
            if (itemMap.has(item.type)) {
              // If the type already exists, sum the amounts
              const existingAmount = itemMap.get(item.type);
              itemMap.set(item.type, existingAmount + amount);
            } else {
              // If not, add the item type and amount to the map
              itemMap.set(item.type, amount);
            }
          });
        };
        // Process both arrays
        addItemToMap(packageItems);
        addItemToMap(directItems);
    
        // Convert the map back to an array of objects
        const combinedArray = Array.from(itemMap, ([type, amount]) => ({
          type,
          amount,
        }));
        console.log('qqqq',combinedArray);
        // Set the merged array in the state
        setMergedItems(combinedArray);
      };
	// Data Fetching
	useEffect(() => {
        setDataLoaded(true);
    }, []);
    
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

    useEffect(() => {
        if(pkgSalesItem.length > 0 && drSalesItem.length > 0){
            setDownloadFlag(true);
        }
    }, [pkgSalesItem,drSalesItem]);
    //search button
	const dataFilter = async () => {
        setDataLoaded(false);
         await axios.get(
                `${process.env.REACT_APP_API_URL}/get_turnover_summary_report`, {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_u_idno: branchidNo,  //branchidNo
            }
        }).then(function (res) {
            console.log('repss',res.data.data.direct_sales.direct_sales_total);
            setPkgSalesItem(res.data.data.package_sales.items); 
            setPkgTurnOverDate(res.data.data.package_sales.turnover_date); 
            setPkgTotal(res.data.data.package_sales.pkg_sales_total);
            setDrSalesItem(res.data.data.direct_sales.items); 
            setDrTurnOverDate(res.data.data.direct_sales.turnover_date); 
            setDrTotal(res.data.data.direct_sales.direct_sales_total);
            setDrPaymentTotal(res.data.data.direct_sales.direct_sales_total);
            handleDataMerge(res.data.data.package_sales.items, res.data.data.direct_sales.items);
            setDataLoaded(true);
		  }).catch(function (error) {	
			console.log(error);
            setDataLoaded(true);
		  });
    }

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };
    
    const columns = [
            {
                name: "type",
                label: "Type",
                options: {
                    filter: false,
                    // display: "excluded",
                },
            },
            {
                name: "amount",
                label: "Amount",
                options: {
                    setCellProps: value => ({ style: { textAlign: 'right' } }),
                }
            },
        ];
 
        const pkgOptions = {
            filter: true,
            // filterType: "dropdown",
            selectableRows: "none",
            filterType: "none",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
            download: false,  //add this
            print: false, //add this
            downloadOptions: {
				filename : 'TurnOverSummaryPackageSales.csv' //change filename of csv
			},
            customFooter: (
                count,
                page,
                rowsPerPage,
                changeRowsPerPage,
                changePage
              ) => {
                const startIndex = page * rowsPerPage;
                const endIndex = (page + 1) * rowsPerPage;
                return (
                  <TableFooter>
                    <TableRow>
                      <TableCell colSpan={6}>
                      Turnover Date: {pkgTurnOverDate} <br/>
                      Total: {pkgTotal}
                        {/* Total Salery for current page: {sumSalery(startIndex, endIndex)} */}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                );
              }
            // tableBodyHeight,
        };
        const drOptions = {
            filter: true,
            // filterType: "dropdown",
            selectableRows: "none",
            filterType: "none",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
            download: false,  //add this
            print: false, //add this
            downloadOptions: {
				filename : 'TurnOverSummaryDirectSales.csv' //change filename of csv
			},
            customFooter: (
                count,
                page,
                rowsPerPage,
                changeRowsPerPage,
                changePage
              ) => {
                const startIndex = page * rowsPerPage;
                const endIndex = (page + 1) * rowsPerPage;
                return (
                  <TableFooter>
                    <TableRow>
                      <TableCell colSpan={6}>
                      Turnover Date: {drTurnOverDate} <br/>
                      Total: {drTotal}
                        {/* Total Salery for current page: {sumSalery(startIndex, endIndex)} */}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                );
              }
            // tableBodyHeight,
        };
        // const sumSalery = (startIndex, endIndex) => {
        //     return data //data = table data
        //       .slice(startIndex, endIndex)
        //       .map(a => a[4])
        //       .reduce((total, salery) => (total += salery), 0);
        //   };

        const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<AssessmentTwoTone />
            				</div>
            				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
							<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
            				<h4 className="header-title">Turn Over Summary</h4>
            			</div>
                        <div className="page-container">
                           <div style={style}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Select Date"
                                            variant="outlined"
                                            onFocus={() => setOpen(true)}
                                            fullWidth={true}
                                            autoComplete="off"
                                            value={`${format(
                                                dateRange.startDate,
                                                "MM/dd/yyyy"
                                            )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                        />
                                        <DateRangePicker
                                            open={open}
                                            toggle={toggle}
                                            onChange={(range) => dateRangeHandler(range)}
                                        /> 
                                    </Grid>
                                    <Grid item xs={1} lg={1} xl={1}>
                                        <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                                    </Grid>
                                    <Grid item xs={2} lg={2} xl={1} alignContent="flex-end">
                                        {console.log('12',drTotal)}
                                        {console.log('14',pkgTotal)}
              {!dataLoaded ? null : (
                <PDFDownloadLink
                  style={{ borderWidth: 1 }}
                  className={classes.buttonPrimary}
                  document={
                    <TurnOverReports
                      pkgSalesItem={pkgSalesItem}
                      drSalesItem={drSalesItem}
                      pkgTurnOverDate={pkgTurnOverDate}
                      pkgTotal={pkgTotal}
                      drTurnOverDate={drTurnOverDate}
                      drTotal={drTotal}
                      mergedItems={mergedItems}
                      drPaymentTotal={drTotal}
                      printby={get_cookies("username")}
                      datePrinted={format(new Date(), "yyyy-MM-dd")}
                      total = {parseFloat(String(drTotal).replace(/,/g, '')) + parseFloat(String(pkgTotal).replace(/,/g, ''))}
                    />
                  }
                  fileName={
                    "TurnoverReport" +
                    format(dateRange.startDate, "yyyy-MM-dd") +
                    format(dateRange.endDate, "yyyy-MM-dd") +
                    ".pdf"
                  }
                >
                  {({ blob, url, loading, error }) =>
                    loading ? (
                      "Loading document..."
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ alignSelf: "flex-end" }}
                      >
                        Print PDF
                      </Button>
                    )
                  }
                </PDFDownloadLink>
              )}
            </Grid>
                                </Grid>        
                            </div>
                        
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
                            <>
            				    <MUIDataTable
            				    		title={
                                            //place header data  here
            				    			<div>
            				    				{/* <div className="table-subtitle">Turn Over Summary</div> */}
            				    				<div className="table-title">
                                                    Package Sales
            				    				</div>
            				    			</div>
            				    		}
            				    		data={pkgSalesItem}
            				    		columns={columns}
            				    		options={pkgOptions}
            				    	/>
                                <br/><br/>
                                <MUIDataTable
            				    		title={
                                            //place header data  here
            				    			<div>
            				    				{/* <div className="table-subtitle">Turn Over Summary</div> */}
            				    				<div className="table-title">
                                                    Direct Sales
            				    				</div>
            				    			</div>
            				    		}
            				    		data={drSalesItem}
            				    		columns={columns}
            				    		options={drOptions}
            				    	/>
                            </>    
            				)}
            			</div>
            		</div>
            	);
};
 
export default TurnOverSummary;